// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `See how high you can rank — join now!`
};

const de_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Sehen Sie, wie hoch Sie steigen können — jetzt mitmachen!`
};

const es_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Ve qué tan alto puedes clasificar — ¡únete ahora!`
};

const fr_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Voyez jusqu'où vous pouvez monter — rejoignez-nous maintenant !`
};

const fi_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Katso kuinka korkealle voit nousta — liity nyt!`
};

const hi_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `देखें आप कितना ऊपर जा सकते हैं — अभी जुड़ें!`
};

const ja_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `どこまで上位に行けるか見てみよう — 今すぐ参加！`
};

const nl_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Zie hoe hoog je kunt komen — doe nu mee!`
};

const pt_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Veja quão alto pode chegar — junte-se agora!`
};

const ro_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Vezi cât de sus poți ajunge — alătură-te acum!`
};

const th_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `ดูว่าคุณสามารถไปได้สูงแค่ไหน — เข้าร่วมตอนนี้!`
};

const ur_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `دیکھیں کہ آپ کتنی اونچائی تک جا سکتے ہیں — اب شامل ہوں!`
};

const zh_hant1_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `看看你能達到多高的排名 — 立即加入！`
};

const da_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Se hvor højt du kan nå — tilmeld dig nu!`
};

const it_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Vedi quanto in alto puoi arrivare — unisciti ora!`
};

const vn_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Xem bạn có thể đạt được vị trí nào — tham gia ngay!`
};

const ko_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `얼마나 높이 올라갈 수 있는지 확인해보세요 — 지금 참가하세요!`
};

const tr_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Ne kadar yükseğe çıkabileceğini gör — şimdi katıl!`
};

const lv_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Redziet, cik augstu varat nokļūt — pievienojieties tagad!`
};

const ar_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `شاهد إلى أي مدى يمكنك الوصول — انضم الآن!`
};

const bs_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Pogledajte koliko visoko možete doći — pridružite se sada!`
};

const sl_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Poglejte, kako visoko lahko pridete — pridružite se zdaj!`
};

const id_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Lihat seberapa tinggi peringkat Anda — bergabunglah sekarang!`
};

const sv_widget_leaderboard_enter_to_rank = /** @type {(inputs: {}) => string} */ () => {
	return `Se hur högt du kan rankas — gå med nu!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_enter_to_rank = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_enter_to_rank(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_enter_to_rank", locale)
	if (locale === "en") return en_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "de") return de_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "es") return es_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "fr") return fr_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "fi") return fi_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "hi") return hi_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "ja") return ja_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "nl") return nl_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "pt") return pt_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "ro") return ro_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "th") return th_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "ur") return ur_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "da") return da_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "it") return it_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "vn") return vn_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "ko") return ko_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "tr") return tr_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "lv") return lv_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "ar") return ar_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "bs") return bs_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "sl") return sl_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "id") return id_widget_leaderboard_enter_to_rank(inputs)
	if (locale === "sv") return sv_widget_leaderboard_enter_to_rank(inputs)
	return "widget_leaderboard_enter_to_rank"
};